import React from "react";
import styled from "styled-components";
import avatar from "../../assets/avatar.png";

const BotAvatar = () => {
  return (
    <BotMain>
      <img src={avatar} alt="" />
    </BotMain>
  );
};

export default BotAvatar;

const BotMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background-color: rgb(58, 170, 53);
  border-radius: 50%;
  cursor: pointer;
  margin-right: 7px;
  img {
    width: 17px;
    height: 17px;
  }
`;
